import { render, staticRenderFns } from "./UserQuickviewForm.vue?vue&type=template&id=ffbaed80&"
import script from "./UserQuickviewForm.vue?vue&type=script&lang=js&"
export * from "./UserQuickviewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports